// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduler-event-content {
  padding: 2px;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
  letter-spacing: 0.01rem;
  height: 100%;
  overflow: hidden;
}
.scheduler-event-content:hover {
  overflow: visible;
}

.fc .fc-scrollgrid {
  border-left-width: 0px;
}
.fc .fc-scrollgrid-section > * {
  border-right-width: 0px;
}

.fc .fc-timegrid-col.fc-day-today {
  background: none;
}

.fc-timegrid-now-indicator-arrow {
  border-color: var(--gray-100) !important;
  border-bottom-color: transparent !important;
  border-top-color: transparent !important;
}
.fc-timegrid-now-indicator-line {
  border-color: var(--gray-100) !important;
  border-style: dotted !important;
}

.fc .fc-timegrid-slot {
  height: 40px;
}
.fc .fc-timegrid-slot-label,
.fc .fc-col-header-cell-cushion {
  color: var(--gray-60);
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.005rem;
}

.fc .fc-v-event {
  background-color: var(--blue-20);
  border: 1px solid var(--blue-20);
  margin: 4px 0 3px 2px;
}
.fc .fc-v-event .fc-event-main {
  color: var(--gray-100);
}

.fc .fc-bg-event {
  background: repeating-linear-gradient(
    135deg,
    var(--gray-20),
    var(--gray-20) 1px,
    var(--gray-10) 0px,
    var(--gray-10) 8px
  ) !important;
  opacity: 0.5;
}

.fc-timegrid-event-harness-inset:hover {
  z-index: 1000 !important;
}
.fc-timegrid-event-harness-inset:hover > .fc-event {
  height: fit-content;
  min-height: calc(100% - 7px);
}
.fc-timegrid-event-harness-inset:hover > .fc-event > .fc-event-main {
  height: fit-content;
}

.fc-event-title-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: block;
}

.fc-non-interactive-event {
  pointer-events: none;
  opacity: 0.7;
}

.fc-highlight {
  min-height: var(--fc-highlight-min-height);
}
`, "",{"version":3,"sources":["webpack://./src/app/SUMO/components/schedulerOfferBookingTimeCalendar/SchedulerOfferBookingTimeCalendar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE;;;;;;cAMY;EACZ,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".scheduler-event-content {\n  padding: 2px;\n  font-size: 10px;\n  line-height: 12px;\n  font-weight: 400;\n  letter-spacing: 0.01rem;\n  height: 100%;\n  overflow: hidden;\n}\n.scheduler-event-content:hover {\n  overflow: visible;\n}\n\n.fc .fc-scrollgrid {\n  border-left-width: 0px;\n}\n.fc .fc-scrollgrid-section > * {\n  border-right-width: 0px;\n}\n\n.fc .fc-timegrid-col.fc-day-today {\n  background: none;\n}\n\n.fc-timegrid-now-indicator-arrow {\n  border-color: var(--gray-100) !important;\n  border-bottom-color: transparent !important;\n  border-top-color: transparent !important;\n}\n.fc-timegrid-now-indicator-line {\n  border-color: var(--gray-100) !important;\n  border-style: dotted !important;\n}\n\n.fc .fc-timegrid-slot {\n  height: 40px;\n}\n.fc .fc-timegrid-slot-label,\n.fc .fc-col-header-cell-cushion {\n  color: var(--gray-60);\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n  letter-spacing: 0.005rem;\n}\n\n.fc .fc-v-event {\n  background-color: var(--blue-20);\n  border: 1px solid var(--blue-20);\n  margin: 4px 0 3px 2px;\n}\n.fc .fc-v-event .fc-event-main {\n  color: var(--gray-100);\n}\n\n.fc .fc-bg-event {\n  background: repeating-linear-gradient(\n    135deg,\n    var(--gray-20),\n    var(--gray-20) 1px,\n    var(--gray-10) 0px,\n    var(--gray-10) 8px\n  ) !important;\n  opacity: 0.5;\n}\n\n.fc-timegrid-event-harness-inset:hover {\n  z-index: 1000 !important;\n}\n.fc-timegrid-event-harness-inset:hover > .fc-event {\n  height: fit-content;\n  min-height: calc(100% - 7px);\n}\n.fc-timegrid-event-harness-inset:hover > .fc-event > .fc-event-main {\n  height: fit-content;\n}\n\n.fc-event-title-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n  display: block;\n}\n\n.fc-non-interactive-event {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.fc-highlight {\n  min-height: var(--fc-highlight-min-height);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
